import { render, staticRenderFns } from "./Transportes.vue?vue&type=template&id=f361c1f8"
import script from "./Transportes.vue?vue&type=script&lang=js"
export * from "./Transportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports